import { IconProps } from './icons-props';

function RightArrowIcon({ className, width = 8, height = 16 }: IconProps) {
    return (
        <svg className={className} width={width} height={height} viewBox='0 0 6 12' xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M1.62774 11.0429C1.85469 11.0437 2.06977 10.9417 2.21274 10.7654L5.83524 6.26545C6.06273 5.9887 6.06273 5.5897 5.83524 5.31295L2.08524 0.812948C1.82015 0.494004 1.34669 0.450352 1.02774 0.715448C0.708799 0.980545 0.665147 1.454 0.930244 1.77295L4.28274 5.79295L1.04274 9.81295C0.855474 10.0377 0.81602 10.3509 0.941684 10.6151C1.06735 10.8793 1.33519 11.0464 1.62774 11.0429Z'
                fill='currentColor'
            />
        </svg>
    );
}

export default RightArrowIcon;

